var _style, _path, _path2, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "right_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#35a4dd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M948.2 512H147.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f9af17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M525.5 65.6L971.9 512 525.5 958.4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.1,
    cy: 512,
    r: 32.5,
    fill: "#35a4dd"
  })));
}

export default SvgRight;